module.exports = __webpack_public_path__ + "7ed005ea484ac5ed3d7554f89f9037ae.png";